<script setup lang="ts">
import useCmd from "@/composables/useCmd";
import { ButtonNormal, ModalCreate, types } from "lorga-ui";
import { toRefs } from "vue";
import { GROUPS_FORM } from "../utils/userGroups";
import { useAuthStore } from "@/features/auth/store";

const props = defineProps<{
  query: () => void;
  userId: string;
  userName: string;
  userGroups: string[];
}>();
const { query } = toRefs(props);

const { updateData } = useAuthStore();

const fields: types.FormField[] = [
  {
    label: "Name",
    name: "name",
    type: "text",
    required: true,
  },
  {
    label: "Gruppen",
    name: "groups",
    type: "checkbox",
    options: GROUPS_FORM,
  },
];

const { commandModalOpen, commandRequest } = useCmd(query, updateData);
</script>

<template>
  <ButtonNormal kind="action" @click="commandModalOpen = true">
    <ModalCreate
      v-model="commandModalOpen"
      submit="Speichern"
      title="User Bearbeiten"
      :data="{
        action: 'user.update',
        name: userName,
        user_id: userId,
        groups: userGroups,
      }"
      :fields="fields"
      :request="commandRequest"
    />
    Bearbeiten
  </ButtonNormal>
</template>
